module.exports = __webpack_public_path__ + "front/img/p18.c78dc4d8.png";